<template>
  <v-autocomplete
    v-model="selectedCollection"
    :items="collections"
    :disabled="loading"
    item-text="collection_name"
    item-value="value"
    prepend-inner-icon="mdi-database-search"
    clearable
    outlined
    required
    light
    :search-input.sync="searchInput"
    :label="
      $t('llm_config.index_parameters.service_client.collection_name_label')
    "
    :placeholder="
      $t(
        'llm_config.index_parameters.service_client.collection_name_placeholder'
      )
    "
    :rules="form_roles.text"
    :elevation="0"
    :menu-props="{ bottom: true, offsetY: true }"
    :error="!!errorMessage"
    :error-count="errorMessage ? 1 : 0"
    :no-data-text="loading ? 'Loading models...' : 'No models found'"
    :error-messages="errorMessage"
    @change="onModelChange"
    @click:prepend-inner="fetchCollections"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.collection_name }}</v-list-item-title>
        <v-list-item-subtitle>
          <span class="text-caption"> Id: {{ item.collection_id }} </span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            {{ loading ? "Loading models..." : "No models found" }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "CollectionsFetch",
  props: {
    database_name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: null,
    },
    form_roles: {
      type: Object,
      default: () => ({
        text: [],
      }),
      required: true,
    },
  },
  data() {
    return {
      collections: [],
      loading: false,
      errorMessage: "",
      searchInput: "",
    };
  },
  computed: {
    selectedCollection: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    searchInput(val) {
      // Debounce search to avoid too many API calls
      if (val && val.length > 0) {
        this.debouncedSearch();
      }
    },
    loading(newVal) {
      this.$emit("loading", newVal);
    },
  },
  async mounted() {
    await this.fetchCollections();
  },
  methods: {
    async fetchCollections() {
      try {
        this.loading = true;
        this.collections = await this.$store.dispatch("FETCH_LLM_COLLECTIONS", {
          database_name: this.database_name,
        });
        //SORT collections alphabetically
        this.collections.sort((a, b) =>
          a.collection_name.localeCompare(b.collection_name)
        );

        //check if current value exists in collections, if not clear it
        const exists = this.collections.some(
          (col) => col.collection_name === this.value
        );
        if (!exists) {
          this.selectedCollection = null;
        }
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: `Error fetching collections`,
          color: "info",
        });
        this.loading = false;
        this.errorMessage = e.message;
        this.$emit("showing_collections_text");
      }
    },
    onModelChange(value) {
      this.$emit("input", value);
    },
    debouncedSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        // You can implement additional filtering here if needed
        // For now, Vuetify's autocomplete handles the filtering
      }, 300);
    },
  },
};
</script>
